<template>
    <div class="project-entry">
      <div class="background-click-detector"></div>
      <div class="project-entry-wrapper">
        <div v-if="is_edit && is_permission_inside('project.task.delete')" class="delete-icon edit-case-name add-button add-pen"         
          @click="delete_dialog = true"> 
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29826 2.40299C9.47656 2.40299 9.625 2.55103 9.625 2.7394V2.91356C9.625 3.09735 9.47656 3.24998 9.29826 3.24998H1.70218C1.52344 3.24998 1.375 3.09735 1.375 2.91356V2.7394C1.375 2.55103 1.52344 2.40299 1.70218 2.40299H3.03855C3.31001 2.40299 3.54626 2.21003 3.60733 1.93778L3.67732 1.6252C3.78608 1.19941 4.14402 0.916626 4.55367 0.916626H6.44633C6.85152 0.916626 7.21348 1.19941 7.31823 1.60274L7.39311 1.93732C7.45374 2.21003 7.68999 2.40299 7.96189 2.40299H9.29826ZM8.61934 8.76972C8.75886 7.46944 9.00313 4.38031 9.00313 4.34914C9.01205 4.25473 8.98129 4.16535 8.92022 4.09339C8.85469 4.02602 8.77178 3.98615 8.6804 3.98615H2.32307C2.23125 3.98615 2.14388 4.02602 2.08326 4.09339C2.02174 4.16535 1.99143 4.25473 1.99589 4.34914C1.99671 4.35487 2.00547 4.46368 2.02013 4.6456C2.08523 5.45376 2.26654 7.70462 2.38369 8.76972C2.4666 9.55438 2.98145 10.0475 3.7272 10.0654C4.30266 10.0787 4.89551 10.0833 5.50174 10.0833C6.07275 10.0833 6.65267 10.0787 7.24597 10.0654C8.01757 10.0521 8.53197 9.56767 8.61934 8.76972Z" fill="#70707E"/>
          </svg>
        </div>
        <div class="popup-exit" @click="close_popup"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" id="SVGDoc" width="22" height="27" version="1.1" viewBox="0 0 22 27"><defs/><desc>Generated with Avocode.</desc><g><g><title>close</title><path d="M9.15986,25.54362c0,0.80252 -0.62895,1.45636 -1.40274,1.45636h-6.35636c-0.77379,0 -1.40274,-0.65384 -1.40274,-1.45636v-23.31371c0,-0.80309 0.62895,-1.45683 1.40274,-1.45683h6.35636c0.77379,0 1.40274,0.65374 1.40274,1.45683c0,0.80328 -0.62895,1.45693 -1.40274,1.45693h-4.95481v20.39928h4.95481c0.77379,0 1.40274,0.65374 1.40274,1.4575zM21.87376,13.93016c0.02015,0.35725 -0.12231,0.74883 -0.39876,1.03903l-4.80282,4.15678c-0.22542,0.23775 -0.58031,0.39129 -0.9588,0.39129c-0.37885,0 -0.73373,-0.15354 -0.99945,-0.43163c-0.54467,-0.56829 -0.54467,-1.49174 0.00119,-2.05879l1.94395,-1.68324h-9.6947c-0.77379,0 -1.40393,-0.65355 -1.40393,-1.45731c0,-0.80252 0.63014,-1.45636 1.40393,-1.45636h9.66263l-1.87135,-1.61791c-0.5852,-0.60673 -0.58639,-1.53074 -0.04172,-2.09885c0.26572,-0.27752 0.6206,-0.43068 0.99945,-0.43068c0.37849,0 0.73338,0.15249 0.99909,0.43068l4.71973,4.07524c0.31924,0.33197 0.4617,0.72327 0.44155,1.14174z" fill="#7b7b8a" fill-opacity="1"/></g></g></svg></div>
        <div class="project-content-wrapper">
          <div class="title-edit-wrapper">            
          <form-input
            label="Naziv zadatka"
            id="naslov-dogadaja"
            ref="naziv"
            required="required"
            placeholder="Unesite naziv zadatka"
            :invalid="is_invalid.naziv"
          ></form-input>
          </div>
          <!-- <div class="project-subtitle">Last changed by you 20 minutes ago</div> -->
          <div class="project-dropdowns clanovi-tima-wrapper">
            <form-autocomplete
              :label="'Dodijeli'"
              type="clanovi_tima"
              id="clanovi-tima-eventi"
              ref="zaduzenici"
              placeholder="Odaberite zaduženike"
              :items="team_members"
            ></form-autocomplete>
            <div class="button-assign-wrapper">
              <div class="button-default button-create" @click="assignToMe">Dodijeli meni</div>
            </div>
          </div>
          <div class="project-dropdowns">
              <form-drop-down
                  label="Status"
                  id="bucket"
                  ref="bucket"
                  :dropImport="statusi_dogadaja"
              ></form-drop-down>
              <form-drop-down
                  label="Prioritet"
                  id="prioritet"
                  ref="prioriteti"
                  :dropImport="event_importance_list"
              ></form-drop-down>
          </div>

          <!-- <div class="form-time-input-wrapper"> -->
          <div class="form-time-input-wrapper">

            <div class="form-input-wrapper form-date">
              <label class="form-label" for="vrijeme-pocetka">
                <span>{{'Rok za završetak'}}</span>
              </label>
                <input
                :class="['form-input', 'date-input']"
                :style="unos_zadatka.datum_zavrsetka == '' ? 'color:#777777' :''"
                type="date"
                id="datum-zavrsetka"
                ref="datumZavrsetka"
                name="datum-zavrsetka"
                v-model="unos_zadatka.datum_zavrsetka"
                />
            </div>
            <!-- <time-picker ref="time2" :is_first="false" label="Vrijeme završetka" /> -->
            <div class="checkbox-wrapper">
              <form-checkbox v-if="is_permission_inside('project.task.archive')" class="checkbox" :id="'arhiviran'" :name="'arhiviran'" :label="'Zadatak arhiviran'" ref="isArchived"></form-checkbox>
            </div>
          </div>
            <!-- <time-picker ref="time1" :is_first="true" label="Vrijeme početka" /> -->
          <!-- </div> -->
          <form-textarea
            label="Opis"
            id="opis"
            ref="opis"
          ></form-textarea>

          <!-- <div class="form-input-wrapper">
                <section class="section avenue-messenger">

                    <div class="chat">

                        <div class="messages" id="mylist" >
                            <div class="loading-spinner"></div>
                            <div class="messages-content">
                                <div>

                                    <div class="message" >
                                        <div class="message-sender">
                                            Karlo Kuparić
                                        </div>
                                        <figure class="avatar"><img src="@/assets/img/avatars/1643271942.jpeg" /></figure> Ovo je komentar na ovo...
                                        <div class="timestamp">21.07.2021. &check;</div>
                                    </div>
                                    <div class="message" >
                                        <div class="message-sender">
                                            Goran Vrban
                                        </div>
                                        <figure class="avatar"><img src="@/assets/img/avatars/1643271942.jpeg" /></figure> Kupa kaj delaš?!
                                        <div class="timestamp">21.07.2021. &check;</div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </section>
                <div class="message-box-wrapper">
                    <div class="message-box">
                        <input type="text" class="message-input" placeholder="Napišite komentar..." />
                    
                        <button type="submit" class="message-submit" >Pošalji</button>
                    </div>
                </div> 
            </div> -->

          <check-list label="Podzadaci" placeholder="Unesi novi podzadatak" ref="podzadaci" />


             


          <div class="form-input-wrapper">
            <label class="form-label" for="privici">
              <span>Privici</span>
            </label>
            <div :class="['loading-spinner',is_hovering ? 'active' : '']"></div>
            <div :class="[ 'project-attachments', is_hovering ? 'active' : '']" @dragover.prevent="is_hovering = true" @dragleave.prevent="is_hovering = false" @drop.prevent="drop">
                <div class="attachment-row existing" v-for="(privitak, key) in unos_zadatka.privici" :key="key">
                  <span @click="getAttachment(privitak.id, privitak.name)" class="existing-attachment">{{privitak.name}}</span>
                    <div
                        class="remove-checklist-item"
                        @click="deleteSubtask(privitak,1)"
                    > 
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29826 2.40299C9.47656 2.40299 9.625 2.55103 9.625 2.7394V2.91356C9.625 3.09735 9.47656 3.24998 9.29826 3.24998H1.70218C1.52344 3.24998 1.375 3.09735 1.375 2.91356V2.7394C1.375 2.55103 1.52344 2.40299 1.70218 2.40299H3.03855C3.31001 2.40299 3.54626 2.21003 3.60733 1.93778L3.67732 1.6252C3.78608 1.19941 4.14402 0.916626 4.55367 0.916626H6.44633C6.85152 0.916626 7.21348 1.19941 7.31823 1.60274L7.39311 1.93732C7.45374 2.21003 7.68999 2.40299 7.96189 2.40299H9.29826ZM8.61934 8.76972C8.75886 7.46944 9.00313 4.38031 9.00313 4.34914C9.01205 4.25473 8.98129 4.16535 8.92022 4.09339C8.85469 4.02602 8.77178 3.98615 8.6804 3.98615H2.32307C2.23125 3.98615 2.14388 4.02602 2.08326 4.09339C2.02174 4.16535 1.99143 4.25473 1.99589 4.34914C1.99671 4.35487 2.00547 4.46368 2.02013 4.6456C2.08523 5.45376 2.26654 7.70462 2.38369 8.76972C2.4666 9.55438 2.98145 10.0475 3.7272 10.0654C4.30266 10.0787 4.89551 10.0833 5.50174 10.0833C6.07275 10.0833 6.65267 10.0787 7.24597 10.0654C8.01757 10.0521 8.53197 9.56767 8.61934 8.76972Z" fill="#70707E"/>
                      </svg>
                  </div>
                </div>
                <div class="section-divider"></div>
                <div class="attachment-row" v-for="(privitak, key) in temp_privici" :key="100+key">
                  <span class="new-attachment">{{privitak.name}}</span>
                    <div
                        class="remove-checklist-item"
                        @click="deleteSubtask(privitak,0)"
                    >
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29826 2.40299C9.47656 2.40299 9.625 2.55103 9.625 2.7394V2.91356C9.625 3.09735 9.47656 3.24998 9.29826 3.24998H1.70218C1.52344 3.24998 1.375 3.09735 1.375 2.91356V2.7394C1.375 2.55103 1.52344 2.40299 1.70218 2.40299H3.03855C3.31001 2.40299 3.54626 2.21003 3.60733 1.93778L3.67732 1.6252C3.78608 1.19941 4.14402 0.916626 4.55367 0.916626H6.44633C6.85152 0.916626 7.21348 1.19941 7.31823 1.60274L7.39311 1.93732C7.45374 2.21003 7.68999 2.40299 7.96189 2.40299H9.29826ZM8.61934 8.76972C8.75886 7.46944 9.00313 4.38031 9.00313 4.34914C9.01205 4.25473 8.98129 4.16535 8.92022 4.09339C8.85469 4.02602 8.77178 3.98615 8.6804 3.98615H2.32307C2.23125 3.98615 2.14388 4.02602 2.08326 4.09339C2.02174 4.16535 1.99143 4.25473 1.99589 4.34914C1.99671 4.35487 2.00547 4.46368 2.02013 4.6456C2.08523 5.45376 2.26654 7.70462 2.38369 8.76972C2.4666 9.55438 2.98145 10.0475 3.7272 10.0654C4.30266 10.0787 4.89551 10.0833 5.50174 10.0833C6.07275 10.0833 6.65267 10.0787 7.24597 10.0654C8.01757 10.0521 8.53197 9.56767 8.61934 8.76972Z" fill="#70707E"/>
                      </svg>
                  </div>
                </div>
                <label :class="['form-input', 'attachments-wrapper', is_hovering ? 'active' : '']">
                  <div class="items-holder">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" id="SVGDoc" width="14" height="21" version="1.1" viewBox="0 0 14 21"><defs/><desc>Generated with Avocode.</desc><g><g><title>Shape 3</title><path d="M6.70195,21.0001c-3.69596,0 -6.70195,-2.81801 -6.70195,-6.283v-8.79622c0,-0.46329 0.40042,-0.83771 0.89347,-0.83771c0.49341,0 0.89371,0.37441 0.89371,0.83771v8.79622c0,2.54002 2.20454,4.60749 4.91476,4.60749c2.71022,0 4.91464,-2.06747 4.91464,-4.60749v-9.21516c0,-1.61676 -1.40285,-2.93198 -3.12746,-2.93198c-1.72472,0 -3.12757,1.31521 -3.12757,2.93198v8.37765c0,0.69265 0.60129,1.25637 1.34039,1.25637c0.73898,0 1.34027,-0.56372 1.34027,-1.25637v-7.9587c0,-0.46329 0.40054,-0.83771 0.89359,-0.83771c0.49329,0 0.89371,0.37441 0.89371,0.83771v7.9587c0,1.61676 -1.40309,2.93188 -3.12757,2.93188c-1.7246,0 -3.12757,-1.31512 -3.12757,-2.93188v-8.37765c0,-2.53992 2.20442,-4.60749 4.91476,-4.60749c2.71022,0 4.91464,2.06757 4.91464,4.60749v9.21516c0,3.46498 -3.00598,6.283 -6.70183,6.283z" fill="#3326ae" fill-opacity="1"/></g></g></svg>
                    <span>Dodaj privitke</span>
                  </div>

                  <input
                    @change="onChange"
                    multiple
                    type="file"
                    id="assetsFieldHandle"
                    ref="file"
                    style="display:none;"
                  />
                </label>
              </div>
          </div>
          <div v-if="added_by != ''" class="project-subtitle">Kreirao: {{added_by.value != undefined && added_by.value != null ? added_by.value : ''}}
          </div>
          <InvalidElementsList v-if="error_list.length != 0" :error_list="error_list"/>
        </div>
        <div v-if="change_exists && is_permission_inside('project.task.edit')" class="button-create-wrapper" @click="!is_waiting_on_insert ? saveChanges() : ''">
          <div class="button-default button-create" >
            <svg
              v-if="is_waiting_on_insert"
              class="update-event-spin"
              viewBox="0 0 50 50"
            >
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="8"
              ></circle>
            </svg>
            <span v-else>Spremi izmjene</span>
          </div>
        </div>
        <v-dialog v-model="delete_dialog" width="564px">
          <v-card color="universal-vcard">
            <div class="universal-vdialog-title">
                Jeste li sigurni da želite obrisati zadatak?
            </div>
            <div class="vdialog-buttons-wrapper wrapper-three-buttons">
              <div class="universal-vdialog-button vbutton-secondary" @click="delete_dialog = false"> Odustani </div>
              <div class="universal-vdialog-button vbutton-primary"  @click="deleteTask()"> Obriši </div>
            </div>
          </v-card>
        </v-dialog>
      </div>
      <v-snackbar
        v-model="snackbar"
        :timeout="snackTimeout"
        color="snack-custom-dark-blue"
        elevation="24"
      >
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            U redu
          </v-btn>
        </template>
      </v-snackbar>
    </div>
</template>

<script>
import formDropDown from "@/components/formElements/formDropDown.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formInput from "@/components/formElements/formInput.vue";
import timePicker from "@/components/formElements/timePicker.vue";
import checkList from "@/components/formElements/checkList.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import InvalidElementsList from "@/components/generalComponents/InvalidElementsList.vue";
import permissioner from "@/services/permissioner.js"
import gsap from 'gsap';
import $ from 'jquery';
import projCaller from "@/apiCallers/promise_handler_db/projects"
import moment from 'moment';
import auth from "@/services/auth";
import formCheckbox from "@/components/formElements/formCheckbox.vue";

export default {
    components:{
        formDropDown,
        "form-textarea": formTextarea,
        "time-picker": timePicker,
        "form-autocomplete": formAutocomplete,
        "check-list": checkList,
	      "form-input": formInput,
        "form-checkbox": formCheckbox,
        InvalidElementsList
    },
    props:['statusi_dogadaja','event_importance_list','team_members','accessToken', 'group_url', 'init_team','attachment_root', 'is_edit'],
    data() {
        return {
            menu1:false,
            menu2:false,
            today_date:'',
            task_name:'',
            error_list:[],
            is_invalid:{
              naziv:false,
            },
            filelist:[],
            unos_zadatka:{
              naziv:{value:''},
              zaduzenici:{results_final:[]},
              bucket:{ID:0},
              prioritet:{non_int_id:'low'},
              datum_zavrsetka:'',
              opis:{value:''},
              podzadaci:{checklist:[]},
              privici:[],
              deleted_privici:[],
              is_archived:false,
            },
            changes_made:{
              naziv:false,
              zaduzenici:false,
              bucket:false,
              prioritet:false,
              datum_zavrsetka:false,
              opis:false,
              podzadaci:false,
              privici:false,
              new_privici:false,
              is_archived:false,
            },
            is_waiting_on_insert:false,
            initial_data: {
              naziv:"",
              zaduzenici:[],
              bucket:0,
              prioritet:"low",
              datum_zavrsetka:"",
              opis:"",
              podzadaci:[],
              privici:[],
              is_archived:false,
            },
            change_exists: false,
            temp_privici: [],
            delete_dialog:false,
            refreshKey:0,
            snackbar: false,
            snackTimeout: 4000,
            snackText: '',
            is_hovering:false,
            added_by:''
        }
    },
    computed:{
    },
    watch:{
      "$store.state.edit_data": {
        handler: function(){
          if (this.$store.state.edit_data != null) {
            this.connect_existing_data();
            this.added_by = this.init_team.find(it=>this.$store.state.edit_data.added_by == it.link)
          }
          else{
             this.setInitValues();
          }
        },
      },
      changes_made: {
        handler(){
          for (const key in this.changes_made) {
            if (this.changes_made[key]) {
              this.change_exists = true;
              break;
            }
            this.change_exists = false;
          }
        },
        deep:true
      },
      "$store.state.project_task_progress": {
        handler: function(){
          this.unos_zadatka.bucket.ID = this.$store.state.project_task_progress;
        }
      },
      'unos_zadatka.naziv.value':function (newva, old) {
        if (newva != this.initial_data.naziv) {
          this.changes_made.naziv = true;
        }
        else{
          this.changes_made.naziv = false;
        }
      },
      'unos_zadatka.is_archived.value':function (newva, old) {
        if (newva != this.initial_data.is_archived) {
          this.changes_made.is_archived = true;
        }
        else{
          this.changes_made.is_archived = false;
        }
      },
      'unos_zadatka.zaduzenici.results_final':function (newva,old) {
        if(!this.equalArrays(newva, this.initial_data.zaduzenici)){
          this.changes_made.zaduzenici = true;
        }
        else{
          this.changes_made.zaduzenici = false;
        }
      },
      'unos_zadatka.bucket.ID':function (newva,old) {
        if (this.$store.state.edit_data == null) {
          if(newva != this.$store.state.project_task_progress){
            this.changes_made.bucket = true;
          }
          else{
            this.changes_made.bucket = false;
          }
        }
        else{
          if (this.initial_data.bucket != newva) {
            this.changes_made.bucket = true;
          }
          else{
            this.changes_made.bucket = false;
          }
        }

      },
      'unos_zadatka.prioritet.non_int_id':function (newva,old) {
        if(newva != this.initial_data.prioritet){
          this.changes_made.prioritet = true;
        }
        else{
          this.changes_made.prioritet = false;
        }
      },
      'unos_zadatka.datum_zavrsetka':function (newva,old) {
        if (newva != this.initial_data.datum_zavrsetka) {
          this.changes_made.datum_zavrsetka = true;
        }
        else{
          this.changes_made.datum_zavrsetka = false;
        }
      },
      'unos_zadatka.opis.value':function (newva,old) {
        if(newva != this.initial_data.opis){
          this.changes_made.opis = true;
        }
        else{
          this.changes_made.opis = false;
        }
      },
      'unos_zadatka.podzadaci.checklist': {
        handler(newva,old){
          if(!this.equalArrays(newva, this.initial_data.podzadaci)){
            this.changes_made.podzadaci = true;
          }
          else{
            this.changes_made.podzadaci = false;
          }
        },
        deep:true
      },
      'unos_zadatka.privici': {
        handler (newva,old){
          if(!this.equalArrays(newva, this.initial_data.privici)){
            this.changes_made.privici = true;
          }
          else{
            this.changes_made.privici = false;
          }
        },
        deep:true,
      },
      temp_privici:function(){
        if(this.temp_privici.length != 0){
          this.changes_made.new_privici = true;
        }
        else{
          this.changes_made.new_privici = false
        }
      }
    },
    methods:{
      is_permission_inside(wanted_permission) {
        return permissioner.check_project_permission(wanted_permission)
      },
      drop(event) {
        event.preventDefault();
        this.$refs.file.files = event.dataTransfer.files;
        this.is_hovering=false;
        this.onChange(); // Trigger the onChange event manually
      },
      connect_existing_data(){
        this.refreshKey++;
        this.initial_data = {
            naziv:this.$store.state.edit_data.title,
            zaduzenici:this.$store.state.edit_data.event_lawyer_connector.map((odvj)=>{
              return {
                'UID':odvj.odvjetnik.uid,
                'is_fiz':true,
                'name': odvj.odvjetnik.ime+' '+odvj.odvjetnik.prezime,
                'status_id':1
              }
            }),
            bucket:this.$store.state.edit_data.status_id,
            prioritet:this.$store.state.edit_data.importance_id,
            datum_zavrsetka:moment(this.$store.state.edit_data.end_date_time).format("YYYY-MM-DD"),
            opis:this.$store.state.edit_data.body,
            podzadaci:this.$store.state.edit_data.subtasks.map(a => {return {...a}}),
            privici:this.$store.state.edit_data.attachment_urls,
            is_archived: this.$store.state.edit_data.is_archived,
          }
        this.unos_zadatka.naziv.value=this.$store.state.edit_data.title;
        this.unos_zadatka.is_archived.value=this.$store.state.edit_data.is_archived;
        let new_team = this.$store.state.edit_data.event_lawyer_connector.map((odvj)=>{
              return {
                'UID':odvj.odvjetnik.uid,
                'is_fiz':true,
                'name': odvj.odvjetnik.ime+' '+odvj.odvjetnik.prezime,
                'status_id':1
              }
            })
        this.unos_zadatka.zaduzenici.results_final=new_team;
        this.unos_zadatka.bucket.ID=this.$store.state.edit_data.status_id
        this.unos_zadatka.prioritet.non_int_id=this.$store.state.edit_data.importance_id
        this.unos_zadatka.datum_zavrsetka=this.$store.state.edit_data.end_date_time != '' ? moment(this.$store.state.edit_data.end_date_time).format("YYYY-MM-DD") : '';
        this.unos_zadatka.opis.value=this.$store.state.edit_data.body
        this.unos_zadatka.podzadaci.checklist=this.$store.state.edit_data.subtasks;
        this.unos_zadatka.privici=this.$store.state.edit_data.attachment_urls;
        var updated_team_members=[];
        this.team_members.forEach((it)=>{
          if (!new_team.some(e=>e.UID == it.link)) {
            updated_team_members.push(it);
          }
        })
        this.$emit("update_team", updated_team_members)
      },
      equalArrays(array1,array2){
          return JSON.stringify(array1) === JSON.stringify(array2);
      },
      validate(){
        this.error_list = [];
        this.is_invalid={
            naziv:false,
        };
        if (this.unos_zadatka.naziv.value == "") {
          this.error_list.push("Potrebno je unijeti naziv zadatka");
          this.is_invalid.naziv = true;
        }
        return this.error_list.length == 0 ? true : false;
      },
      async saveChanges(){
        this.is_waiting_on_insert = true;
        if(this.validate()){
          const formData = new FormData();
          for (let i = 0; i < this.temp_privici.length; i++) {
            formData.append("files", this.temp_privici[i]);
          }
          let object_to_insert = {
            naziv: this.unos_zadatka.naziv.value,
            zaduzenici: this.unos_zadatka.zaduzenici.results_final,
            bucket: this.unos_zadatka.bucket.ID,
            prioritet: this.unos_zadatka.prioritet.non_int_id,
            datum_zavrsetka: this.unos_zadatka.datum_zavrsetka == "" ? undefined : this.unos_zadatka.datum_zavrsetka+"T00:00",
            opis: this.unos_zadatka.opis.value,
            podzadaci: this.unos_zadatka.podzadaci.checklist.length == 0 ? []: this.unos_zadatka.podzadaci.checklist,
            group_url: this.group_url,
            attachment_root: this.attachment_root,
            deleted_privici: this.unos_zadatka.deleted_privici,
            existing_privici: this.unos_zadatka.privici,
            is_archived: this.unos_zadatka.is_archived.value,
          }
          formData.append("event",JSON.stringify(object_to_insert));
          formData.append("token", this.accessToken);
          formData.append("person_uid", this.$store.state.logged_in_user.uid);
          formData.append("team_list", JSON.stringify(this.init_team));
          formData.append("case_uid", this.$route.params.uid);
          formData.append("is_case", this.$route.name == 'CasePlaner');

          if (this.$store.state.edit_data == null) {
            await projCaller.addNewProjectTask(formData).then((resp)=>{
              this.is_waiting_on_insert = false;
              this.close_popup();
            });
          }
          else{
            formData.append("event_uid", this.$store.state.edit_data.uid);
            await projCaller.updateProjectTask(formData).then((resp)=>{
              this.is_waiting_on_insert = false;
              this.close_popup();
            })
          }

        }
        this.is_waiting_on_insert = false;
      },
      setInitValues(){
        this.$refs.naziv.$data.value = '';
        this.unos_zadatka.datum_zavrsetka='';
        this.unos_zadatka.privici=[];
        this.unos_zadatka.deleted_privici=[];
        this.$refs.zaduzenici.$data.results_final = [];
        this.$refs.bucket.$data.ID = 0;
        this.$refs.prioriteti.$data.non_int_id = "low";
        this.$refs.opis.$data.value = "";
        this.$refs.podzadaci.$data.checklist = [];
        this.$refs.isArchived.$data.value = false;
        this.added_by=''
        this.$emit("refreshTeam");
        this.changes_made = {
          naziv:false,
          zaduzenici:false,
          bucket:false,
          prioritet:false,
          datum_zavrsetka:false,
          opis:false,
          podzadaci:false,
          privici:false,
          new_privici:false,
          is_archived:false,
        };
        this.initial_data= {
          naziv:"",
          zaduzenici:[],
          bucket:0,
          prioritet:"low",
          datum_zavrsetka:"",
          opis:"",
          podzadaci:[],
          privici:[],
          is_archived:false,
        };
        this.$store.state.edit_data = null;
        this.temp_privici = [];
      },
      assignToMe(){
        if (!this.$refs.zaduzenici.$data.results_final.find(el=>el.UID == this.$store.state.logged_in_user.uid)) {
          this.$refs.zaduzenici.$data.results_final.push({
            'UID':this.$store.state.logged_in_user.uid,
            'is_fiz':true,
            'name':this.$store.state.logged_in_user.ime + ' '+this.$store.state.logged_in_user.prezime,
            'status_ID':1
          });
          this.$emit('update_team',this.team_members.filter((fiz)=>fiz.link != this.$store.state.logged_in_user.uid))
        }
      },
      close_popup(){
        if (!this.is_waiting_on_insert) {
          this.setInitValues();
          this.$store.state.project_task_progress = 0;
          gsap.to(".project-entry",0,{display:'none'})
        }
      },
      onChange(){
        const add_files = [...this.$refs.file.files];
        const final_files = add_files.filter((file)=>file.size < 57671680);
        const num_odbacenih = add_files.length - final_files.length;
        if (num_odbacenih != 0) {
          this.snackbar = true;
          this.snackText =
            "Zbog ograničenja Sharepoint-a odbačeno je " + num_odbacenih + " datoteka veličine iznad 55MB.";
        }
        this.temp_privici = this.temp_privici.concat(final_files);
      },
      deleteSubtask(privitak, type){
        if (type == 0) {
          this.temp_privici = this.temp_privici.filter((priv)=>priv != privitak);
        }
        else{
          this.unos_zadatka.deleted_privici.push(this.unos_zadatka.privici.find(priv=>priv == privitak));
          this.unos_zadatka.privici = this.unos_zadatka.privici.filter(priv=>priv != privitak);
        }
      },
      async deleteTask(){
        this.delete_dialog = false;
        this.is_waiting_on_insert = true;
        this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        await projCaller.deleteTask(this.accessToken, this.$store.state.edit_data.uid,  JSON.stringify(this.init_team), this.$route.params.uid, JSON.stringify(this.$store.state.edit_data.attachment_urls),this.group_url, this.$route.name == 'CasePlaner').then((resp)=>{
          this.is_waiting_on_insert = false;
          this.close_popup();
        }).catch((err)=>{});
      },
      async getAttachment(attach_id,file_name){
        this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        await projCaller.getTaskAttachment(this.accessToken, this.group_url, attach_id).then((resp)=>{
          //pripremanje download linka
          var link = document.createElement("a");
          link.setAttribute("href", resp.data.webUrl);
          link.setAttribute("target", "_blank");
          link.setAttribute("download", file_name);
          link.click();
        })
      },
      docClick(e){
        if ($(".background-click-detector").is(e.target)) {
          this.close_popup();
        }
      }
    },
    mounted() {
      this.$refs.bucket.$data.ID = 0;
      this.$refs.prioriteti.$data.non_int_id= "low";

      this.unos_zadatka.naziv = this.$refs.naziv.$data;
      this.unos_zadatka.zaduzenici = this.$refs.zaduzenici.$data;
      this.unos_zadatka.bucket = this.$refs.bucket.$data;
      this.unos_zadatka.prioritet = this.$refs.prioriteti.$data;
      this.unos_zadatka.opis = this.$refs.opis.$data;
      this.unos_zadatka.podzadaci = this.$refs.podzadaci.$data;
      this.unos_zadatka.is_archived = this.$refs.isArchived.$data;

      document.addEventListener('click', this.docClick);
    },
    beforeDestroy() {
      document.removeEventListener('click', this.docClick);
    },
}
</script>